import { Button } from 'components/atoms';
import { MagellanPopups } from 'components/molecules';
import { Form } from 'components/organisms';
import { useParamId } from 'hooks/useParamId';
import middleware from 'middleware';
import { useTranslation } from 'react-i18next';
import { PiPencilSimpleLine } from 'react-icons/pi';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { PopupActions } from 'reactjs-popup/dist/types';
import {
  useDeleteAgreementTemplate,
  useGetAgreementTemplate,
} from 'services/templates/agreement-template';
import { contractTemplateUtil } from 'utils';
import { onErrorShowToast } from 'utils/service/errorHandler';

const AgreementTemplate = () => {
  const id = useParamId('/templates-extended');
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const isParagraphKind = searchParams.get('kind') === 'paragraph';

  const agreementTemplate = useGetAgreementTemplate(id);
  const removeAgreementTemplate = useDeleteAgreementTemplate(id);

  const name = agreementTemplate.data
    ? agreementTemplate.data?.title
    : undefined;

  const editPath = isParagraphKind
    ? `/templates-extended/agreement/edit/${id}/form?kind=paragraph`
    : `/templates-extended/agreement/edit/${id}/form`;

  const onRemoveAgreementTemplateTemplate = async (actions: PopupActions) => {
    await removeAgreementTemplate.mutateAsync(undefined, {
      onError: error => {
        actions.close();
        onErrorShowToast(error);
      },
      onSuccess: () => navigate('/templates-extended'),
    });
  };

  const getInitialValues = () => {
    if (!agreementTemplate.data) {
      return isParagraphKind
        ? contractTemplateUtil.agreement.initialParagraphValues()
        : contractTemplateUtil.agreement.initialValues();
    }

    return isParagraphKind
      ? middleware.template.agreement.queryToParagraphForm(agreementTemplate.data)
      : middleware.template.agreement.queryToForm(agreementTemplate.data);
  };

  return (
    <Form.Contract
      tittle={
        name ??
        (isParagraphKind
          ? t('contract-template.paragraphAgreement.title')
          : t('contract-template.agreement.title'))
      }
      backPath={'templates-extended'}
      topbarContent={
        <div className='flex'>
          <Button
            isClear
            onlyIcon
            onClick={() =>
              navigate(editPath, {
                replace: true,
              })
            }>
            <Button.Description description={t('button.edit')} />

            <Button.Icon icon={<PiPencilSimpleLine />} />
          </Button>
          <MagellanPopups.DeleteWarning
            onRemove={onRemoveAgreementTemplateTemplate}
            removeLoading={removeAgreementTemplate.isPending}
            name={name}
          />
        </div>
      }
      initialStatus={{
        ...contractTemplateUtil.agreement.initialStatus,
        displayMode: true,
      }}
      initialValues={getInitialValues()}
      onSubmit={() => {}}
      status={{ displayMode: true, isLoading: agreementTemplate.isLoading }}
    />
  );
};

export default AgreementTemplate;
